module.exports = __webpack_public_path__ + "static/media/gitbucket.e25b0923.svg";